import { render } from "./FeedbackFrom.vue?vue&type=template&id=643ace4d&scoped=true"
import script from "./FeedbackFrom.vue?vue&type=script&lang=js"
export * from "./FeedbackFrom.vue?vue&type=script&lang=js"

import "./FeedbackFrom.vue?vue&type=style&index=0&id=643ace4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-643ace4d"]])

export default __exports__